export default __webpack_public_path__ + "static/media/ordered-list.d26e95e7.svg";